import styled from "@emotion/styled";
import theme from "@theme";
import background from "@assets/images/background.webp";
import InnoIcons from "InnoUI/innoicons";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  margin: -8px -8px -8px -8px;
  font-family: Roboto;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;
const LogoLoginImage = styled.div`
  flex: 1;
  positon: relative;
  background-image: url(${background}); /* Correct property */
  background-color: rgba(0, 0, 0, 0.2);
  background-size: cover; /* Make sure the image covers the entire div */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Prevent the image from repeating */
  z-index: 1000 @media (max-width: 1024px) {
    display: flex;
  }

  @media (min-width: 1025px) {
    display: flex;
  }
  @media (max-width: 600px) {
    display: none;
  }
`;

const Login = styled.div`
  flex: 1;
  display: flex;
  height: 100%;
  font-size: 12px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colors.white};
`;

const LoginForm = styled.div`
  background-color: ${theme.colors.white};
  padding: 10px;
  border-radius: 25px;
  width: 60%;
  height: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;

  @media (min-width: 768px) {
    width: 60%;
  }

  @media (min-width: 1025px) {
    width: 50%;
  }
`;

const Form = styled.form``;

const Logo = styled.img`
  width: 200px;
  height: 50px;
  position: absolute;
  top: 20px;
  left: 20px;

  @media (max-width: 767px) {
    position: relative;
    align-self: auto;
    margin-bottom: 25px;
    margin-top: -10px;
  }
`;

const LoginImage = styled.img`
  display: none;
  width: 100%;
  height: 100%;
  @media (min-width: 768px) {
    display: block;
    width: 417px;
    height: 311px;
    align-self: center;
  }

  @media (min-width: 1024px) {
    display: flex;
    width: 500px;
    height: 333px;
  }
  @media (min-width: 1440px) {
    display: flex;
    width: 650px;
    height: 440px;
  }
`;

const Label = styled.label`
  color: ${theme.colors.black};
  width: Hug (69px) px;
  height: Hug (19px) px;
  gap: 10px;
  opacity: 0px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 400;
  line-height: 19px;
`;

const TransparentInput = styled.input`
  width: 92%;
  padding: 2px 2px 2px 20px;
  margin-bottom: 15px;
  background-color: transparent;
  color: ${theme.colors.black};
  font-size: 16px;
  font-family: Roboto;
  outline: none;
  border: 1px solid grey;
  border-radius: 8px;
  height: 30px;
  &::placeholder {
    opacity: 0.5;
    color: ${theme.colors.black};
    font-size: 12px;
    font-family: Roboto;
  }
`;
const TransparentInputt = styled.input`
  width: 100%;
  padding: 8px 40px 8px 15px; /* Ensures space for the icon */
  background-color: transparent;
  color: ${theme.colors.black};
  font-size: 16px;
  font-family: Roboto;
  outline: none;
  border: 1px solid grey;
  border-radius: 8px;
  height: 18px;

  &::placeholder {
    opacity: 0.5;
    color: ${theme.colors.black};
    font-size: 12px;
    font-family: Roboto;
  }
`;

const PasswordInputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const ToggleButton = styled.button`
  position: absolute;
  top: 50%;
  right: 10px; /* Adjusted for better alignment */
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: ${theme.colors.black};
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
`;

const ImageContainer = styled.img`
  width: 200px;
  height: 120px;
  margin-bottom: 10px;
`;

const Button = styled.button`
  width: 100%;
  border: none;
  background: ${theme.gradient.themeGradient};
  color: ${theme.colors.white};
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border-radius: 5px;
  margin: 10px 0px 25px 0px;
  height: 35px;
  text-align: center;
  gap: 10px;
  border-radius: 8px;
  opacity: 0px;
  @media (min-width: 768px) {
    width: 100%; /* Adjust for larger screens */
  }
  @media (max-width: 768px) {
    width: 100%; /* Adjust for larger screens */
  }
`;
const Heading = styled.p`
  color: #565656;
  margin-top: -10px;
  margin-bottom: 10px;
  font-weight: bold;
  font-family: Roboto;
  font-size: 40px;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 30px;
  }
`;

const ErrorMessage = styled.div`
  color: red;
  margin-top: 10px;
`;

const pdiv = styled.div`
  font-family: Roboto;
  font-size: 45px;
  font-weight: 700;
  letter-spacing: -0.04em;
  text-align: center;
  position: absolute;
  bottom: 100px;
  width: 50%;
  gap: 0px;
  opacity: 0px;
  color: ${theme.colors.white};
`;

const textspan = styled.span`
  font-family: Roboto;
  font-size: 80px;
  font-weight: 900;
  letter-spacing: -0.04em;
  text-align: center;
  background: ${theme.gradient.themeGradient};
  -webkit-background-clip: text; /* Clip background to text */
  -webkit-text-fill-color: transparent; /* Make text fill transparent */
`;

const Forgetdiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const checkboxdiv = styled.div`
  font-family: Roboto;
  display: flex;
  align-items: center;
  text-align: center;
  gap: 3px;
`;
const Forgetpass = styled.p`
  text-align: center;
  font-family: Roboto;
  text-decoration: none;
  background: #e96b04;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
const RequestAccessunderline = styled.p`
  text-align: center;
  font-family: Roboto;
  text-decoration: underline;
  color: transparent;
  background: #e96b04;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 0 0 #e96b04;
`;
const MainDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  position: relative;
  margin-bottom: 10px;
  @media (min-width: 1400px) {
  width:  310px; /* Adjust for larger screens */
  height: 35px;
`;
const ChildDivTwo = styled.div`
  display: flex;
  align-items: center;
  border-radius: 12px;
  height: 2rem;
  background-color: ${theme.colors.white};
  padding: 0 10px;
  font-size: 16px;
  font-weight: bold;
  color: #5b5b5b;
  position: relative;
  z-index: 1;
`;
const ChildDivOneThree = styled.div`
  border-top: 1px dashed ${theme.colors.bordertask};
  flex: 1;
`;
const Cursorimg = styled.img`
  height: 12px;
  width: 12px;
  margin-top: 34px;
`;
const Requestform = styled.div`
  margin-top: 5px;
  display: flex;
  width: 90%;
  height: 60%;
  flex-direction: column;
`;
const Requestdiv = styled.div`
  display: flex;
`;
const messagedetails = styled.div`
  width: 40%;
  font-weight: 700;
  margin-top: -10px;
`;

const Reqdetails = styled.p`
  width: 100%;
  margin: 0;
  padding: 0;
  color: #979797;
  font-size: 12px;
  font-weight: 300;
  display: flex;
`;

const bottomDiv = styled.div`
  flex: 1;
  color: white;
  width: 45%;
  position: absolute;
  padding: 30px;
  bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Forgetpage = styled.div`
  flex: 1;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid red;
  background-color: ${theme.colors.white};
`;
const forgetHeading = styled.p`
  font-family: Roboto;
  font-size: 32px;
  font-weight: 500;
  letter-spacing: -0.02em;
  text-align: left;
  color: #565656;
  margin-bottom: 35px;
  width: 100%;
  @media (min-width: 1300px) {
    width: 340px; /* Adjust for larger screens */
  }
`;
const forgetpara = styled.p`
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 18.75px;
  letter-spacing: 0.01em;
  text-align: left;
  color: #565656cc;
  gap: 0px;
  opacity: 0px;
  width: 100%;
  margin-top: -30px;
  @media (min-width: 1300px) {
    width: 340px; /* Adjust for larger screens */
  }
`;

const backButton = styled.button`
  color: #000000;
  width: 100%;
  border: none;
  font-size: 12px;
  cursor: pointer;
  border-radius: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
  height: 35px;
  text-align: center;
  gap: 10px;
  border-radius: 8px;
  opacity: 0px;
  background: white;
`;
const RequestCont = styled.div`
  flex: 1;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  background-color: ${theme.colors.white};
`;
const textarea = styled.textarea`
  width: 86%;
  height: 100px;
  margin-left: 13px;
  box-sizing: border-box;
  border: 1px solid ${theme.colors.grey};
  background-color: #f8f8f8;
  font-size: 16px;
  resize: none;
  border-radius: none;
  &:focus {
    border: 1px solid ${theme.colors.grey} !important;
  }

  @media (min-width: 768px) {
    width: 86%; /* Adjust for larger screens */
  }
  @media (max-width: 768px) {
    width: 86%; /* Adjust for larger screens */
  }
`;
const subjectInput = styled.input`
  width: 85%;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 20px;
  background-color: transparent;
  color: ${theme.colors.black};
  font-size: 16px;
  font-family: Roboto;
  outline: none;
  border: 1px solid grey;
  height: 25px;
  &::placeholder {
    opacity: 0.5;
    color: ${theme.colors.black};
    font-size: 16px;
    font-family: Roboto;
  }  
  }
    @media (min-width: 768px) {
    width: 85%; /* Adjust for larger screens */
    
  }
    @media (max-width: 768px) {
    width: 85%; /* Adjust for larger screens */
  }
`;
const RequestHeading = styled.p`
  font-family: Roboto;
  font-size: 32px;
  font-weight: 500;
  letter-spacing: -0.02em;
  text-align: left;
  color: #565656;
  width: 100%;
  margin-top: 0;
`;
const ReqButton = styled.button`
  width: 50%;
  jusitfy-content: center;
  border: none;
  background: ${theme.gradient.themeGradient};
  color: ${theme.colors.white};
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border-radius: 5px;
  margin-top: 5px;
  height: 35px;
  text-align: center;
  gap: 10px;
  border-radius: 8px;
  opacity: 0px;
  @media (min-width: 768px) {
    width: 50%; /* Adjust for larger screens */
  }
`;

const VisibilityIcon = styled(InnoIcons.VisibilityIcon)`
  width: 15px;
  margin-top: 5px;
`;
const VisibilityOffIcon = styled(InnoIcons.VisibilityOffIcon)`
  width: 15px;
  margin-top: 5px;
`;

const imagecontainer = styled.img`
  width: 200px;
  height: 60px;
  margin: 0px 0px 10px 0px;
  object-fit: contain;
`;

const SC = {
  Container,
  LogoLoginImage,
  Login,
  LoginForm,
  LoginImage,
  Label,
  TransparentInput,
  PasswordInputContainer,
  ToggleButton,
  Button,
  Heading,
  ErrorMessage,
  Form,
  pdiv,
  textspan,
  Forgetdiv,
  checkboxdiv,
  ImageContainer,
  Forgetpass,
  ChildDivOneThree,
  MainDiv,
  ChildDivTwo,
  Requestform,
  Cursorimg,
  forgetHeading,
  forgetpara,
  Forgetpage,
  backButton,
  bottomDiv,
  RequestCont,
  Requestdiv,
  messagedetails,
  Reqdetails,
  textarea,
  subjectInput,
  RequestHeading,
  ReqButton,
  TransparentInputt,
  RequestAccessunderline,
  VisibilityIcon,
  VisibilityOffIcon,
  imagecontainer,
};

export default SC;
